import { experimentReviewPackage } from '../core/experimentReview'
import type { ReasonNode, Session } from '../core/types'

/** The existing revision journal owns the join; do not copy its execution
 * provenance onto nodes where it can diverge from the actual receipt. */
export function ExperimentEvidenceBlock({ session, node }: { session: Session; node: ReasonNode }) {
  const workspace = session.research?.experiments
  const revisions =
    workspace?.revisions?.filter((revision) => revision.produced.includes(node.id)) ?? []
  if (!workspace || !revisions.length) return null
  return (
    <div className="group">
      <div className="group-head">
        <b>Executed experiment behind this finding</b>
      </div>
      {revisions.map((revision) => {
        const receipt = workspace.receipts.find((row) => row.id === revision.receiptId)
        if (!receipt) return <p key={revision.id}>Receipt {revision.receiptId} is unavailable.</p>
        let packet = ''
        try {
          packet = JSON.stringify(experimentReviewPackage(receipt, revision.review), null, 2)
        } catch (error) {
          packet = error instanceof Error ? error.message : 'The public package is unavailable.'
        }
        return (
          <details key={revision.id}>
            <summary>
              Receipt {receipt.id} · revision {revision.state}
            </summary>
            <p>
              {revision.review
                ? `Declared ${revision.review.kind.replaceAll('-', ' ')}: ${revision.review.scope}`
                : 'Historical review: no public artifact disclosure was retained with its request.'}
            </p>
            <p>
              Input digest {receipt.inputDigest}. Execution alone does not certify this claim or
              establish a universal result.
            </p>
            <p>
              This inspection is reconstructed from the retained receipt and disclosure selection.
              The operation's exact request records what the reviewer received.
            </p>
            <pre style={{ maxHeight: 320, overflow: 'auto', whiteSpace: 'pre-wrap' }}>{packet}</pre>
          </details>
        )
      })}
    </div>
  )
}
